import { Injectable, OnDestroy } from "@angular/core";
import { User } from "@angular/fire/auth";
import { Subscription } from "rxjs";

import { AuthCoreService } from "anatoliapps-angular/auth";

/**
 * Service responsible for managing authentication operations and user state
 * Handles user authentication, registration, profile updates, and password management
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService extends AuthCoreService implements OnDestroy {

  //#region Subscriptions
  /**
   * Subscription to track authentication state changes
   * Used to automatically sign in anonymously when no user is present
   */
  readonly #userSubscription: Subscription;
  //#endregion

  //#region Constructor
  /**
   * Initializes the authentication service
   * Sets up automatic anonymous authentication when no user is present
   */
  constructor() {
    super();

    // Subscribe to auth state changes to maintain continuous anonymous authentication
    this.#userSubscription = this.authState$.subscribe((user: User | null) => {
      // If no user is detected (null), automatically create an anonymous session
      // This ensures we always have a user context for operations that require authentication
      if (user === null) {
        this.signInAnonymously();
      }
    });
  }
  //#endregion

  //#region Lifecycle Hooks
  /**
   * Cleans up subscriptions when the service is destroyed
   */
  ngOnDestroy(): void {
    // Prevent memory leaks by unsubscribing from the auth state subscription
    this.#userSubscription.unsubscribe();
  }
  //#endregion

}